(() => {
  if (window.AlvyaWelcomeCouponCopyInitialized) return;

  window.AlvyaWelcomeCouponCopyInitialized = true;

  const fallbackCopy = (value) => {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    textarea.remove();
    if (!copied) throw new Error('Copy failed');
  };

  const copyCoupon = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    fallbackCopy(value);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-welcome-coupon-copy]');
    if (!button) return;

    const label = button.querySelector('[data-welcome-coupon-label]');
    const feedback = button.parentElement.querySelector('[data-welcome-coupon-feedback]');
    const originalLabel = button.dataset.couponCode;

    window.clearTimeout(button.resetCouponTimer);

    try {
      await copyCoupon(originalLabel);
      label.textContent = button.dataset.copiedLabel;
      feedback.textContent = button.dataset.copiedAnnouncement;
      button.classList.add('is-copied');

      button.resetCouponTimer = window.setTimeout(() => {
        label.textContent = originalLabel;
        feedback.textContent = '';
        button.classList.remove('is-copied');
      }, 1600);
    } catch (error) {
      feedback.textContent = button.dataset.copyFailed;
    }
  });
})();
